import type { MaybeRef } from 'vue'
import type { MaybeEstimatedSerie } from '@/types/charts.types'

export function useChartSeriesVisible(series: MaybeRef<MaybeEstimatedSerie[]>) {
  const seriesRef = ref(series)
  const seriesVisible = ref<string[]>([])

  onMounted(() => {
    resetSeriesVisible()
  })

  watch(seriesRef, (newValue, oldValue) => {
    if (newValue !== oldValue) {
      resetSeriesVisible()
    }
  })

  function resetSeriesVisible() {
    seriesVisible.value
      = unref(series).map((dataset) => {
        return dataset.name || ''
      }) || []
  }

  return {
    seriesVisible,
    resetSeriesVisible,
  }
}
